export default "Nu er det jeres tur til at få gang i kroppen og sved på panden ved at lege kronhjorte på forskellig vis! ";